import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Target, TrendingUp, AlertTriangle, ClockIcon } from '../../../../images/icons/icons';
import { fetchClosurePipelineCriticalTrackingOverviewData } from '../../../../redux/prospect-reducers/prospectSlice';
import ReactVortoxSpinner from '../../../common-components/ReactVortoxSpinner';

const DashboardMetrics = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { closurePipelineCriticalTrackingOverview, closurePipelineCriticalTrackingOverviewLoading } = useSelector((state) => state.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  // Filters state
  const initialFilters = {
    gym_id: !isAdmin && !isMarketing && !isClusterManager ? userInfoData?.gym_id || "" : "",
  };
  const [filters, setFilters] = useState(initialFilters);

  // // Keep filters in sync with gym_id
  // useEffect(() => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     gym_id: userInfoData?.gym_id || "",
  //   }));
  // }, [userInfoData?.gym_id]);

  // Fetch overview data when token and filters are ready
  useEffect(() => {
    if (!userInfoData?.token) return;
    dispatch(
      fetchClosurePipelineCriticalTrackingOverviewData({
        filters,
        token: userInfoData?.token,
      })
    );
  }, [dispatch, userInfoData?.token, filters]);


  const metrics = [
    {
      title: "Active Leads",
      value: closurePipelineCriticalTrackingOverview?.data?.active_leads || "0",
      icon: Target,
      color: "blue"
    },
    {
      title: "Total Value",
      value: `₹ ${closurePipelineCriticalTrackingOverview?.data?.total_value || "0"}`,
      icon: TrendingUp,
      color: "green"
    },
    {
      title: "Stuck Over 3 Days",
      value: closurePipelineCriticalTrackingOverview?.data?.stuck_over_3_days || "0",
      icon: AlertTriangle,
      color: "red"
    },
    {
      title: "Avg Days",
      value: closurePipelineCriticalTrackingOverview?.data?.avg_days || "0",
      icon: ClockIcon,
      color: "orange"
    }
  ];

  const getIconColor = (color) => {
    switch (color) {
      case "blue":
        return "lms-closure-pipeline-tracker-metric-icon-blue";
      case "green":
        return "lms-closure-pipeline-tracker-metric-icon-green";
      case "red":
        return "lms-closure-pipeline-tracker-metric-icon-red";
      case "orange":
        return "lms-closure-pipeline-tracker-metric-icon-orange";
      default:
        return "lms-closure-pipeline-tracker-metric-icon-default";
    }
  };

  const getValueColor = (color) => {
    if (color === "red") return "lms-closure-pipeline-tracker-metric-value-red";
    return "lms-closure-pipeline-tracker-metric-value-default";
  };

  return (
    <div className="lms-closure-pipeline-tracker-dashboard-metrics">
      <div className="lms-closure-pipeline-tracker-metrics-container">
        {closurePipelineCriticalTrackingOverviewLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 120 }}>
            <ReactVortoxSpinner />
          </div>
        ) : metrics?.map((metric, index) => {
          const IconComponent = metric?.icon;
          return (
            <div key={index} className="lms-closure-pipeline-tracker-metric-card">
              <div className="lms-closure-pipeline-tracker-metric-header">
                <div className={`lms-closure-pipeline-tracker-metric-icon-wrapper ${getIconColor(metric?.color)}`}>
                  <IconComponent className="lms-closure-pipeline-tracker-metric-icon" />
                </div>
              </div>
              <div className={`lms-closure-pipeline-tracker-metric-value ${getValueColor(metric?.color)}`}>
               <h4 className="lms-closure-pipeline-tracker-metric-title">{metric?.title}</h4>
               <p>{metric?.value}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DashboardMetrics; 